import React, { useEffect, useState, useContext, useRef, Children } from 'react';
import { Spin, Button, Popover, Modal, Col, Space, DatePicker, Form, Input, InputNumber, Table, Row, Select, Switch, TreeSelect, QRCode, Typography, Tree, Tooltip } from 'antd';
import Icon, { SearchOutlined, PlusOutlined, ExclamationCircleOutlined, DeleteOutlined, EllipsisOutlined, PropertySafetyFilled, ControlOutlined, ToolOutlined } from '@ant-design/icons';
import { ProTable, TableDropdown } from '@ant-design/pro-components';
import axios from 'axios';
const { RangePicker } = DatePicker;
const ImportButton = ({
    handleImport,
    handleDownload,
    set_upload_modal,
    upload_modal,
    importData,
    setImportData,
    columns,
    import_modal,
    set_import_modal,
    handleOver,
    handleReserve,
    loading
}) => {
    const [data, setData] = useState([]);
    const ref = useRef(0);
    const handleImportModal = (e) => {
        set_upload_modal(true);
    }
    useEffect(() => {
        // console.log(importData);
        if (importData.length != 0) {
            set_import_modal(true);
            setData(importData);
        } else {
            set_import_modal(false)
        }
    }, [importData])
    const handlePreOver = () => {
        let data_tmp = [];
        data && data.map((value) => {
            if (value.type == 'both')
                data_tmp.push({ value });
        })
        if (data_tmp.length != 0) {
            handleOver(data_tmp);
        }
    }
    const handlePreReserve = () => {
        let data_tmp = [];
        data && data.map((value) => {
            if (value.type == 'name')
                data_tmp.push({ value });
        })
        if (data_tmp.length != 0) {
            handleReserve(data_tmp);
        }
    }
    return (
        <>
            <Modal
                style={{ pointerEvents: 'auto' }}
                open={upload_modal}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                width={450}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <Spin tip="上傳中" spinning={loading} style={{ background: 'white' }}>
                        <div style={{ backgroundColor: '#faf6f5', padding: '30px', borderTop: `solid #d65b77 5px `, position: 'relative', minHeight: '25vh' }}>
                            <Row gutter={[10, 10]} justify='center' >
                                <Col span={24}>
                                    <Row gutter={[10, 10]} justify={"center"}>
                                        <Col>
                                            <Button size='large' style={{ background: 'rgba(43, 193, 123, 1)', color: '#ffffff' }} onClick={(e) => handleDownload()} block>範例檔案下載</Button>
                                        </Col>
                                        <Col>
                                            <Button size='large' style={{ backgroundColor: '#41A084', color: '#FFFFFF' }} onClick={(e) => ref.current.click()} block>檔案上傳</Button>
                                            <input type="file" id="my_file" hidden ref={ref} onChange={(e) => handleImport(e)} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
                                    <Row gutter={[10, 10]} justify={"center"}>
                                        <Col>
                                            <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => { set_upload_modal(false); }} block>取消</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Spin>
                </>}
            ></Modal>
            <Modal
                style={{ pointerEvents: 'auto' }}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                open={import_modal}
                width={1000}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: '#faf6f5', padding: '30px', borderTop: `solid #d65b77 5px `, position: 'relative', minHeight: '25vh' }}>
                        <Row gutter={[10, 10]} justify={'center'}>
                            <Col span={24}>
                                <Row gutter={[16, 10]}>
                                    <Col>
                                        <Button type='primary' onClick={handlePreReserve}>全部保留</Button>
                                    </Col>
                                    <Col>
                                        <Button style={{ backgroundColor: 'rgba(232, 79, 117, 1)', color: '#FFFFFF' }} onClick={handlePreOver}>全部覆蓋</Button>
                                    </Col>
                                    <Col>
                                        <Button style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={e => set_import_modal(false)}>全部取消</Button>
                                    </Col>
                                    <Col span={24}>
                                        <Table
                                            tableLayout={'fixed'}
                                            scroll={{ x: 'max-content' }}
                                            columns={columns}
                                            dataSource={data}
                                            pagination={false}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Button style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={e => set_import_modal(false)}>關閉</Button>
                            </Col>
                        </Row>
                    </div>
                </>}
            ></Modal >
            <Button type='file' className='example' style={{ backgroundColor: '#41A084', color: '#FFFFFF' }} onClick={(e) => handleImportModal()}>匯入資料</Button>

        </>
    )

}
export default ImportButton;